import React from 'react';
import { Text, TextLink, TextProps } from '../typography';

interface LegalFeesConsentProps extends TextProps {
  path?: string;
}

const LegalFeesConsent: React.FC<LegalFeesConsentProps> = ({ path, ...props }) => {
  return (
    <Text fontSize={12} mt={10} {...props}>
      By clicking the “Email Millar McCall Wylie” button you confirm that you consent to PropertyPal sharing your
      information with Millar McCall Wylie and to Millar McCall Wylie using, storing, processing and transferring your
      personal data for the purposes and in the manner outlined in this{' '}
      <TextLink
        href={`/conveyancing-consent-terms${path ? `?path=${path}` : ''}`}
        prefetch={false}
        data-testid="legal-terms-link"
      >
        Privacy Statement
      </TextLink>
      .
    </Text>
  );
};

export default LegalFeesConsent;
